import { FlexBox, Box as StyledBox } from '@onegov/react-component-library';
import { Box, Button, H4 } from '@snsw/react-component-library';
import { formatBytes } from '@snsw/react-component-library/build/utils';
import React from 'react';
import styles from '../Page.module.scss';

export const UploadedCertificates = ({ title, uploadedFile, onUpdate }) => {
  return (
    <>
      <H4 className={styles.marginTopOneHalf}>{title}</H4>
      <Box style={{ marginTop: '1rem', marginBottom: '0.5rem', marginRight: '1rem' }}>
        <FlexBox gap={1} alignItems={'strecth'}>
          <StyledBox flex="1" display="flex">
            <strong>
              {uploadedFile?.name} ({formatBytes(uploadedFile?.size)})
            </strong>
          </StyledBox>
          <StyledBox display="flex">
            <Button variant="link" onClick={onUpdate}>
              Update
            </Button>
          </StyledBox>
        </FlexBox>
      </Box>
    </>
  );
};
